const menu = {
  label: '• Tipo Certificado',
  to: '/sol/tipocertificado',
  rules: ['SOL-001'],
}

export default menu;